import React from 'react';
import { CustomRedirect, CustomNavLink } from './base';
import { prefixTo } from './helpers';
import { connect, DispatchProp } from 'react-redux';
import { RedirectProps } from 'react-router';
import { NavLinkProps } from 'react-router-dom';
import { IState } from '@/state/IState';

const mapStateToProps = (state: IState) => ({
    profile: state.global.activeProfile,
});

type ICommonProps = ReturnType<typeof mapStateToProps> & DispatchProp;

export const ProfileRelativeRedirect = connect(mapStateToProps)(({ profile, to, dispatch, ...rest }: ICommonProps & RedirectProps) => (
    <CustomRedirect to={prefixTo(to, "/")} {...rest} />
));

export const ProfileRelativeLink = connect(mapStateToProps)(({ profile, to, children, dispatch, ...rest }: ICommonProps & NavLinkProps) => (
    <CustomNavLink to={prefixTo(to, "/")} {...rest}>
        {children}
    </CustomNavLink>
));